export const EquationCardKind = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードを直接指定します</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_kind.png`}></img>
            <p>図の例では戦士というカードを指定しています </p>
            </div>
    )
}
